import * as React from 'react';

import {KPIBox} from '@spaced-out/ui-design-system/lib/components/KPIBox';
import {KPIShimmer} from '@spaced-out/ui-design-system/lib/components/Shimmer';
import {spaceFluid} from '@spaced-out/ui-design-system/lib/styles/variables/_space';


export const BYOD_KPI_DEFAULT_ICON = 'chart-line';

export type ByodKpiBoxProps = {
  label: string;
  middleContent: React.ReactNode;
  semantic?: 'neutral' | 'danger';
  widgetIcon?: string | null;
  /** CSS module class for KPIBox / KPIShimmer wrapper (sizing/layout per surface). */
  kpiboxWrapperClassName: string;
  /** When true, renders `KPIShimmer` in place of `KPIBox` (same wrapper class). */
  isLoading?: boolean;
  /**
   * Optional content below the value (KPIBox bottomContent) — e.g. the KPI trend
   * line. Omitted ⇒ the box renders value-only, exactly as before.
   */
  bottomContent?: React.ReactNode;
};

export function ByodKpiBox({
  label,
  middleContent,
  semantic = 'neutral',
  widgetIcon,
  kpiboxWrapperClassName,
  isLoading = false,
  bottomContent,
}: ByodKpiBoxProps) {
  if (isLoading) {
    return (
      <KPIShimmer
        classNames={{wrapper: kpiboxWrapperClassName}}
        textWidth={spaceFluid}
        hasIcon
        hasTopContent
        hasMiddleContent
        hasBottomContent={bottomContent != null}
      />
    );
  }

  const iconName =
    typeof widgetIcon === 'string' && widgetIcon.trim().length > 0
      ? widgetIcon.trim()
      : BYOD_KPI_DEFAULT_ICON;

  return (
    <KPIBox
      semantic={semantic}
      iconName={iconName}
      iconSize="large"
      topContent={label}
      middleContent={middleContent}
      {...(bottomContent != null ? {bottomContent} : {})}
      classNames={{
        wrapper: kpiboxWrapperClassName,
      }}
    />
  );
}
